module.exports = __webpack_public_path__ + "img/goods-4.fc1bc62c.png";